import { TablePaginationConfig } from 'antd/lib/table';

export const DEFAULT_PAGINATION_OPTIONS: false | TablePaginationConfig = {
  position: ['bottomRight'],
  defaultCurrent: 1,
  showSizeChanger: true,
};
